/* Chezvia product page UX
   1) "Size Guide" link next to the Size label (pattern copied from Spark Paws) opening the size chart in a popup.
   2) Changing only the size never touches the gallery or scrolls the page.
   3) Changing the color (or style/print) swaps the photo and, on phones, scrolls up to the gallery
      so the shopper sees it (on desktop the gallery is sticky and already visible).
   4) Sticky mobile Add to cart that always works and never adds twice. */
(function () {
  var lastOption = null;
  function isVisual(name) { return /colou?r|style|design|pattern|print/i.test(name || ''); }

  function galleryTarget() {
    var g = document.querySelector('product-info media-gallery') || document.querySelector('media-gallery');
    if (!g) return null;
    var header = document.querySelector('sticky-header') || document.querySelector('.section-header');
    var offset = header ? header.getBoundingClientRect().height : 0;
    return Math.max(0, g.getBoundingClientRect().top + window.pageYOffset - offset - 8);
  }
  /* Scroll up to the photos; the page can still shift while Dawn swaps the media,
     so check again shortly after and finish the move if it stopped short. */
  function showGallery() {
    if (window.matchMedia('(min-width: 750px)').matches) return;
    var t = galleryTarget();
    if (t === null || window.pageYOffset - t < 40) return;
    window.scrollTo({ top: t, behavior: 'smooth' });
    [600, 1300].forEach(function (ms) {
      setTimeout(function () {
        var t2 = galleryTarget();
        if (t2 !== null && Math.abs(window.pageYOffset - t2) > 40 && window.pageYOffset - t2 < 1500) window.scrollTo(0, t2);
      }, ms);
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t && t.closest && t.closest('variant-selects'))) return;
    lastOption = t.name || '';
    if (isVisual(lastOption)) setTimeout(showGallery, 60);
  }, true);

  function patch() {
    var PI = customElements.get('product-info');
    if (PI && !PI.prototype.__cz) {
      var updateMedia = PI.prototype.updateMedia;
      PI.prototype.updateMedia = function (html, id) {
        if (lastOption !== null && !isVisual(lastOption)) return;
        return updateMedia.call(this, html, id);
      };
      PI.prototype.__cz = true;
    }
    var MG = customElements.get('media-gallery');
    if (MG && !MG.prototype.__cz) {
      var setActiveMedia = MG.prototype.setActiveMedia;
      MG.prototype.setActiveMedia = function (mediaId, prepend) {
        if (!prepend) return setActiveMedia.call(this, mediaId, prepend);
        var realScrollTo = window.scrollTo;
        window.scrollTo = function () {};
        try { setActiveMedia.call(this, mediaId, prepend); }
        finally { setTimeout(function () { window.scrollTo = realScrollTo; }, 80); }
      };
      MG.prototype.__cz = true;
    }
  }
  ['product-info', 'media-gallery'].forEach(function (n) { customElements.whenDefined(n).then(patch); });

  /* ---------- Size Guide link + popup ---------- */
  var css = '' +
    '.cz-sg-link{background:none;border:0;padding:0;margin-left:auto;font:inherit;font-size:1.3rem;font-weight:600;color:#C26B4A;text-decoration:underline;text-underline-offset:3px;cursor:pointer;letter-spacing:0;text-transform:none}' +
    'legend.cz-has-sg{display:flex;align-items:center;width:100%;gap:1rem}' +
    '.cz-sg-modal{border:0;padding:0;width:min(560px,94vw);max-height:88vh;border-radius:14px;background:#FBF8F2;color:#253238;box-shadow:0 18px 50px rgba(0,0,0,.25)}' +
    '.cz-sg-modal::backdrop{background:rgba(37,50,56,.55)}' +
    '.cz-sg-modal__bar{position:sticky;top:0;display:flex;justify-content:flex-end;padding:.8rem;background:#FBF8F2;z-index:1}' +
    '.cz-sg-modal__close{border:0;background:#EFE7DB;width:3.6rem;height:3.6rem;border-radius:50%;font-size:2rem;line-height:1;cursor:pointer;color:#253238}' +
    '.cz-sg-modal__body{padding:0 1.6rem 2rem;overflow:auto}' +
    '.product__accordion:has([id^="Details-cz-size-guide-"]){display:none}';

  function ensureStyle() {
    if (document.getElementById('cz-sg-style')) return;
    var s = document.createElement('style'); s.id = 'cz-sg-style'; s.textContent = css; document.head.appendChild(s);
  }

  function openGuide() {
    var src = document.querySelector('.cz-sg');
    if (!src) return;
    var d = document.getElementById('CzSgModal');
    if (!d) {
      d = document.createElement('dialog'); d.id = 'CzSgModal'; d.className = 'cz-sg-modal';
      d.innerHTML = '<div class="cz-sg-modal__bar"><button type="button" class="cz-sg-modal__close" aria-label="Close">&times;</button></div><div class="cz-sg-modal__body"></div>';
      document.body.appendChild(d);
      d.querySelector('.cz-sg-modal__close').addEventListener('click', function () { d.close(); });
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    }
    d.querySelector('.cz-sg-modal__body').innerHTML = src.outerHTML;
    if (d.showModal) d.showModal(); else d.setAttribute('open', '');
  }

  function addLink() {
    if (!document.querySelector('.cz-sg')) return;
    document.querySelectorAll('variant-selects fieldset').forEach(function (fs) {
      var lg = fs.querySelector('legend');
      if (!lg || lg.querySelector('.cz-sg-link')) return;
      var input = fs.querySelector('input[type="radio"]');
      var name = (input && input.name) || lg.textContent;
      if (!/size/i.test(name)) return;
      ensureStyle();
      lg.classList.add('cz-has-sg');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cz-sg-link'; b.textContent = 'Size Guide';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openGuide(); });
      lg.appendChild(b);
    });
  }

  function init() {
    if (!document.querySelector('variant-selects')) return;
    addLink();
    var root = document.querySelector('product-info') || document.body;
    new MutationObserver(function () { addLink(); }).observe(root, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* ---------- Sticky Add to cart (mobile) ----------
     Dawn re-renders the main Add to cart button on variant change, so look it up fresh every time,
     show "Adding..." while the request runs and ignore extra taps. */
  function sticky() {
    var bar = document.getElementById('CzStickyAtc');
    var old = document.getElementById('CzStickyBtn');
    if (!bar || !old || bar.__cz) return;
    bar.__cz = true;
    var btn = old.cloneNode(true);
    old.parentNode.replaceChild(btn, old);
    var priceEl = document.getElementById('CzStickyPrice');
    var adding = false;
    var st = document.createElement('style');
    st.textContent = '.cz-sticky-atc{transform:translateY(110%)!important}.cz-sticky-atc.cz-on{transform:none!important}.cz-sticky-atc__btn[aria-busy=true]{opacity:.75}';
    document.head.appendChild(st);
    function main() { return document.querySelector('product-form button[name="add"]'); }
    function busy(m) { return m.classList.contains('loading') || m.getAttribute('aria-disabled') === 'true'; }
    function sync() {
      var m = main();
      if (!m) return;
      var drawer = document.querySelector('cart-drawer');
      var open = !!(drawer && drawer.classList.contains('active'));
      if (adding && !busy(m) && (!drawer || open)) adding = false;
      btn.disabled = m.disabled;
      btn.setAttribute('aria-busy', adding ? 'true' : 'false');
      var label = m.disabled ? 'Sold out' : (adding ? 'Adding...' : 'Add to cart');
      if (btn.textContent !== label) btn.textContent = label;
      var p = document.querySelector('[id^="price-"] .price-item--last');
      if (p && priceEl && p.textContent.trim() && priceEl.textContent !== p.textContent.trim()) priceEl.textContent = p.textContent.trim();
      bar.classList.toggle('cz-on', m.getBoundingClientRect().bottom < 0 && !open);
    }
    btn.addEventListener('click', function () {
      var m = main();
      if (adding || !m || m.disabled || busy(m)) return;
      adding = true;
      sync();
      m.click();
      setTimeout(function () { adding = false; sync(); }, 6000);
    });
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    var root = document.querySelector('product-info') || document.body;
    new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class', 'aria-disabled', 'disabled'], childList: true, subtree: true });
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sticky); else sticky();
})();